import { CdkContextMenuTrigger } from '@angular/cdk/menu';
import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Warranties, InvoiceBuyOrderMinuteDTO } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/interface/minute-detail';
import { ModalWarrantieIsBuildComponent } from './modal-warrantie-is-build/modal-warrantie-is-build.component';
@Component({
  selector: 'app-warranties-minute',
  templateUrl: './warranties-minute.component.html',
  styleUrls: ['./warranties-minute.component.scss']
})
export class WarrantiesMinuteComponent {
  @Input() warranties: Array<Warranties>;
  @Input() forMinute: boolean = false;
  @Output() invoiceOperationToUpdate = new EventEmitter<Warranties>;
  @Output() warrantiesToRemove = new EventEmitter<number[]>;
  @Output() notify = new EventEmitter<any>;
  @ViewChild(MatSort, { static: true})
  sort: MatSort = Object.create(null);
  public order: any;
  public menu!: CdkContextMenuTrigger;
  public ordenes: InvoiceBuyOrderMinuteDTO;
  public dataSource!: MatTableDataSource<Warranties>;
  public dataSourceOrder!: MatTableDataSource<InvoiceBuyOrderMinuteDTO>;
  public displayedCols = [
    'insuranceCompany',
    'warrantyType',
    'amount',
    'cost',
    'createdAt',
    'endDate',
    'tender',
    'nameTenderBuyer',
    'insuranceBroker',
    'contractAmount',
    'isBuild'
  ];
  
  constructor(private dialog: MatDialog) {
    this.dataSource = new MatTableDataSource<Warranties>([]);
    this.dataSourceOrder = new MatTableDataSource<InvoiceBuyOrderMinuteDTO>([]);
  }
  
  ngOnInit(): void {
    if(!this.forMinute){
      this.displayedCols.push('operationState');
    }
    this.dataSource = new MatTableDataSource<Warranties>([]);
    this.dataSource.sort = this.sort;
    this.dataSourceOrder = new MatTableDataSource<InvoiceBuyOrderMinuteDTO>([]);
    this.dataSourceOrder.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['warranties'] && changes['warranties'].currentValue) {
      this.dataSource.data = changes['warranties'].currentValue;
      this.dataSource.sort = this.sort;
    }
  }

  public selectOperationToUpdate(operation: Warranties) {
    this.invoiceOperationToUpdate.emit(operation);
  }

  public removeWarranty(warranty: Warranties) {
    this.warrantiesToRemove.emit([warranty.warrantyId]);
  }

  public openModalConstruccionWarrantie(data: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.width = '30vw';
    dialogConfig.height = '32vh';
    dialogConfig.maxWidth = '90vw';
    dialogConfig.maxHeight = '85vh';
    dialogConfig.data = data;

    const dialogRef = this.dialog.open(ModalWarrantieIsBuildComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.notify.emit();
    })
  }

}
